<template>
  <div class="chess-loader-mobile">
    <template v-for="i in 3" :key="i">
      <div class="d-flex align-center py-2">
        <skeleton-loader width="230px" />
        <e-icon name="arrowDropdown" :size="10" class="text-inactive ml-3" :class="{ '-rotate': i === 1 }" />
      </div>
      <div v-if="i === 1" class="px-3">
        <template v-for="j in 2" :key="j">
          <div class="d-flex justify-space-between align-center py-3 pl-3">
            <div class="chess-loader-mobile__texts">
              <skeleton-loader width="120px" height="20px" />
              <skeleton-loader width="180px" height="12px" />
            </div>
            <e-icon name="chevronRight" :size="12" class="text-inactive" />
          </div>
          <divider v-if="j < 2" class="my-2" />
        </template>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import Divider from '@/core/components/helpers/Divider.vue';
import SkeletonLoader from '@/core/components/interface/SkeletonLoader.vue';
import { EIcon } from '@/core/components/ui';
</script>

<style scoped lang="scss">
.chess-loader-mobile {
  &__texts {
    display: grid;

    grid-gap: 2px;
  }
}
</style>
